/**
 * Booking notice popup (see snippets/booking-popup.liquid).
 * Links with data-booking-popup="<modal id>" open the popup instead of navigating.
 * "I understand" closes it and continues to the link that opened it.
 */
if (!window.bookingPopupInitialised) {
  window.bookingPopupInitialised = true;

  document.addEventListener('click', (evt) => {
    const trigger = evt.target.closest('[data-booking-popup]');
    if (trigger) {
      const modal = document.getElementById(trigger.dataset.bookingPopup);
      if (!modal || typeof modal.open !== 'function') return;

      evt.preventDefault();
      modal.continueUrl = trigger.getAttribute('href');
      modal.continueTarget = trigger.getAttribute('target');
      modal.open(trigger);
      return;
    }

    const continueBtn = evt.target.closest('.js-booking-popup-continue');
    if (!continueBtn) return;

    const modal = continueBtn.closest('modal-dialog');
    const { continueUrl, continueTarget } = modal;
    modal.close();

    if (!continueUrl) return;
    if (continueTarget === '_blank') {
      window.open(continueUrl, '_blank', 'noopener');
    } else {
      window.location.href = continueUrl;
    }
  });
}
